interface CheckBoxProps {
  checked?: boolean;
}
const CheckBox = ({ checked = true }: CheckBoxProps) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      {checked ? (
        <>
          <rect width="22" height="22" rx="4" fill="#FF8D00" />
          <g clipPath="url(#clip0_1491_6711)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M15.9623 5.81458C15.7301 5.83212 15.524 5.92307 15.3643 6.07857C15.3404 6.10184 15.2734 6.17812 15.2154 6.24808C15.1574 6.31804 13.6706 8.11732 11.9114 10.2465C10.1523 12.3756 8.70948 14.1214 8.70524 14.1259C8.69808 14.1335 8.6278 14.0444 7.71353 12.8685C7.17233 12.1724 6.7116 11.5819 6.68969 11.5563C6.5352 11.3754 6.32423 11.2671 6.06953 11.2379C5.77894 11.2046 5.50289 11.3009 5.28783 11.5108C5.2009 11.5956 5.14102 11.6779 5.09298 11.7785C5.0256 11.9195 4.99533 12.071 5.00058 12.2409C5.00682 12.4424 5.06288 12.6026 5.18615 12.7713C5.21814 12.815 7.29831 15.4899 7.35305 15.5577C7.40206 15.6183 7.51693 15.7341 7.57766 15.784C8.01362 16.1425 8.57718 16.2699 9.12394 16.1335C9.45835 16.05 9.77116 15.8579 10.0028 15.5937C10.0441 15.5465 16.7292 7.45789 16.7896 7.38192C16.8933 7.25151 16.9597 7.10558 16.9877 6.94648C16.9993 6.88059 17.0015 6.74041 16.9922 6.66437C16.964 6.43317 16.8728 6.24877 16.7081 6.08951C16.5018 5.89011 16.2401 5.79362 15.9623 5.81458Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_1491_6711">
              <rect
                width="12"
                height="12"
                fill="white"
                transform="translate(5 5)"
              />
            </clipPath>
          </defs>
        </>
      ) : (
        <rect
          x="1"
          y="1"
          width="20"
          height="20"
          rx="3"
          stroke="#C6CACE"
          strokeWidth="2"
        />
      )}
    </svg>
  );
};

export default CheckBox;
